var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsActionUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.01715 14V13.35C2.01715 13.01 2.17852 12.69 2.43066 12.54C4.13515 11.53 6.08169 11 8.06858 11C8.09884 11 8.11901 11 8.14927 11.01C8.25013 10.31 8.45184 9.64 8.74433 9.03C8.52244 9.01 8.30055 9 8.06858 9C5.62784 9 3.34846 9.67 1.40192 10.82C0.514372 11.34 0 12.32 0 13.35V16H9.33938C8.91578 15.4 8.58295 14.72 8.36107 14H2.01715Z",
    fill: "#009BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06858 8C10.2975 8 12.1029 6.21 12.1029 4C12.1029 1.79 10.2975 0 8.06858 0C5.83964 0 4.03429 1.79 4.03429 4C4.03429 6.21 5.83964 8 8.06858 8ZM8.06858 2C9.17801 2 10.0857 2.9 10.0857 4C10.0857 5.1 9.17801 6 8.06858 6C6.95915 6 6.05144 5.1 6.05144 4C6.05144 2.9 6.95915 2 8.06858 2Z",
    fill: "#009BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9107 12C18.9107 11.78 18.8805 11.58 18.8502 11.37L20 10.36L18.9914 8.63L17.529 9.12C17.2063 8.85 16.8432 8.64 16.4397 8.49L16.1372 7H14.12L13.8174 8.49C13.414 8.64 13.0509 8.85 12.7282 9.12L11.2658 8.63L10.2572 10.36L11.407 11.37C11.3767 11.58 11.3464 11.78 11.3464 12C11.3464 12.22 11.3767 12.42 11.407 12.63L10.2572 13.64L11.2658 15.37L12.7282 14.88C13.0509 15.15 13.414 15.36 13.8174 15.51L14.12 17H16.1372L16.4397 15.51C16.8432 15.36 17.2063 15.15 17.529 14.88L18.9914 15.37L20 13.64L18.8502 12.63C18.8805 12.42 18.9107 12.22 18.9107 12ZM15.1286 14C14.0192 14 13.1114 13.1 13.1114 12C13.1114 10.9 14.0192 10 15.1286 10C16.238 10 17.1457 10.9 17.1457 12C17.1457 13.1 16.238 14 15.1286 14Z",
    fill: "#009BE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsActionUsersIcon);
export default __webpack_public_path__ + "static/media/ProjectsActionUsersIcon.32f2453298a5cb9fd0519e01b325ecec.svg";
export { ForwardRef as ReactComponent };